const EXPERIENCE = [
  {
    role: "Software Engineer",
    company: "JSYS Technologies",
    location: "Lahore, Pakistan",
    period: "Jan 2024 — Jun 2026",
    client: "Rehasaku (Japan)",
    clientNote: " — clinic / healthcare management SaaS",
    links: [
      { label: "facility.rehasaku.net", href: "https://facility.rehasaku.net" },
      { label: "patient.rehasaku.net", href: "https://patient.rehasaku.net" },
    ],
    points: [
      "Built the front-end UI for a clinic-management SaaS end-to-end — covering both the facility-side system (staff management, scheduling, admin modules) and the patient-side portal — for a Japanese healthcare client, from spec through production release.",
      "Designed and built an AI-powered web builder: users upload templates, clients submit annotated redesign requests, and AI prompting automatically regenerates the templates — replacing a manual redesign process with a self-serve workflow.",
      "Built Neo Pedix, a separate doctors' marketplace covering patient-facing search and booking alongside doctor-facing appointment and profile management.",
      "Authored GridScope, a standalone, dependency-free JavaScript calendar / scheduling library, open-sourced on GitHub for reuse outside the project it was built for.",
      "Contributed to back-end microservices in Rust, using Claude Code and AI-assisted development to work productively in a language outside my core stack.",
      "Wrote end-to-end automated test suites with Playwright to cover booking and scheduling flows before release.",
      "Worked directly with the client's team in Japan, translating feature specs and design annotations into shipped, production-ready code.",
    ],
  },
  {
    role: "Full-Stack Developer",
    company: "Orbailix",
    location: "Peshawar, Pakistan",
    period: "Apr 2022 — Nov 2023",
    note: "Company-owned products and client delivery for local non-profit organisations",
    certificate: "/AbdulBasitIqbalOrbailixExperienceCertificate.pdf.pdf",
    points: [
      "Built content management systems for company-owned products, handling both front-end and back-end work in PHP, SQL, HTML and CSS.",
      "Delivered web platforms for local NGO clients, contributing from requirement discussion through to release.",
    ],
  },
];

function Experience() {
  return (
    <section className="section" id="experience">
      <div className="wrap">
        <div className="section-head reveal">
          <h2 className="section-title">
            Experience
          </h2>
          <p className="section-note">
            Where I've shipped — from spec to production, across time zones.
          </p>
        </div>

        {EXPERIENCE.map((e) => (
          <article className="exp-entry reveal" key={e.company}>
            <div className="exp-top">
              <h3 className="exp-role">
                {e.role} <span className="at">— {e.company}</span>
              </h3>
              <span className="exp-period">{e.period}</span>
            </div>
            <p className="exp-meta">
              {e.location}
              {e.client ? (
                <>
                  {" · "}Client: <strong>{e.client}</strong>
                  {e.clientNote}
                </>
              ) : e.note ? (
                <>{" · "}{e.note}</>
              ) : null}
            </p>
            {e.links && (
              <p className="exp-links">
                <span className="exp-links-label">Live</span>
                {e.links.map((l) => (
                  <a key={l.href} href={l.href} target="_blank" rel="noreferrer">
                    {l.label}
                  </a>
                ))}
              </p>
            )}
            <ul className="exp-points">
              {e.points.map((p, i) => (
                <li key={i}>{p}</li>
              ))}
            </ul>
            {e.certificate && (
              <a
                className="exp-cert"
                href={e.certificate}
                target="_blank"
                rel="noreferrer"
              >
                Experience certificate
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M7 17L17 7M17 7H8M17 7V16" />
                </svg>
              </a>
            )}
          </article>
        ))}
      </div>
    </section>
  );
}

export default Experience;
